// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* Featured image styling */
.featured-image-container[data-v-7e3d76b8] {
  position: relative;
  overflow: hidden;
  border-radius: 0.75rem;
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
}
.featured-image-article[data-v-7e3d76b8] {
  width: 100%;
  height: auto;
  transition: transform 0.5s ease;
  border: 1px solid rgba(0,0,0,0.08);
}
.featured-image-container:hover .featured-image-article[data-v-7e3d76b8] {
  transform: scale(1.02);
}

/* Add a subtle gradient overlay for better text readability if caption exists */
.featured-image-container[data-v-7e3d76b8]::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100px;
  background: linear-gradient(to top, rgba(0,0,0,0.05), transparent);
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.3s ease;
}
.featured-image-container[data-v-7e3d76b8]:hover::after {
  opacity: 1;
}
.figure-caption[data-v-7e3d76b8] {
  font-size: 0.875rem;
  color: #6c757d;
  font-style: italic;
}
.article-content[data-v-7e3d76b8] {
  font-size: 1.125rem;
  line-height: 1.8;
}
.article-content[data-v-7e3d76b8] h1,
.article-content[data-v-7e3d76b8] h2,
.article-content[data-v-7e3d76b8] h3,
.article-content[data-v-7e3d76b8] h4,
.article-content[data-v-7e3d76b8] h5,
.article-content[data-v-7e3d76b8] h6 {
  font-weight: 600;
  margin-top: 2rem;
  margin-bottom: 1rem;
}
.article-content[data-v-7e3d76b8] p {
  margin-bottom: 1.25rem;
}
.article-content[data-v-7e3d76b8] ul,
.article-content[data-v-7e3d76b8] ol {
  margin-bottom: 1.25rem;
  padding-left: 1.5rem;
}
.article-content[data-v-7e3d76b8] li {
  margin-bottom: 0.5rem;
}
.article-content[data-v-7e3d76b8] blockquote {
  border-left: 4px solid #dee2e6;
  padding-left: 1rem;
  margin: 1.5rem 0;
  font-style: italic;
  color: #6c757d;
}
.article-content[data-v-7e3d76b8] pre {
  background-color: #f8f9fa;
  border-radius: 0.375rem;
  padding: 1rem;
  margin-bottom: 1.25rem;
  overflow-x: auto;
}
.article-content[data-v-7e3d76b8] code {
  background-color: #f8f9fa;
  padding: 0.125rem 0.25rem;
  border-radius: 0.25rem;
  font-size: 0.875em;
  color: #e83e8c;
}
.article-content[data-v-7e3d76b8] pre code {
  background-color: transparent;
  padding: 0;
  color: inherit;
}
.article-content[data-v-7e3d76b8] img {
  max-width: 100%;
  height: auto;
  border-radius: 0.375rem;
}
.article-content[data-v-7e3d76b8] table {
  width: 100%;
  margin-bottom: 1.25rem;
  border-collapse: collapse;
}
.article-content[data-v-7e3d76b8] th,
.article-content[data-v-7e3d76b8] td {
  padding: 0.75rem;
  border: 1px solid #dee2e6;
}
.article-content[data-v-7e3d76b8] th {
  background-color: #f8f9fa;
  font-weight: 600;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
